import styled from 'styled-components';
import { fade, moveDown } from '../../shared/styles';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1rem 0;
`;

export const Name = styled.h1`
	color: ${({ theme }) => theme.text.main};
	margin: 0;
	font-size: 1.5rem;
	text-transform: uppercase;
`;

export const Description = styled.h2`
	color: ${({ theme }) => theme.text.main};
	margin: 0;
	font-size: 0.9rem;
	font-weight: normal;
	line-height: 1.5;
`;

export const Detail = styled.h2`
	color: ${({ theme }) => theme.text.main};
	margin: 0;
	font-size: 0.9rem;
	text-transform: uppercase;

	@media (max-width: 768px) {
		font-size: ${(props) => (props.size ? `0.5rem` : `0.75rem`)};
	}
`;

export const ToolsWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	gap: 0 12px;
	margin-top: 5px;
	margin-bottom: 5px;
`;

export const ProjectCard = styled.div`
	width: 24vw;
	display: flex;
	flex-direction: column;
	align-items: center;

	margin: 1rem 0;
	padding: 1rem;
	box-sizing: border-box;
	opacity: 0;
	animation: 2s ease ${(props) => props.order * 0.15}s normal forwards 1 ${fade},
		2s ease ${(props) => props.order * 0.15}s normal forwards 1 ${moveDown};

	border-style: solid;
	border-width: 1px;
	border-color: ${({ theme }) => theme.text.main};
	border-radius: 15px;

	@media (max-width: 1400px) {
		width: 36vw;
	}

	@media (max-width: 768px) {
		width: 85vw;
	}
`;
